import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=375e98d2&"
import script from "./MessageInput.vue?vue&type=script&lang=js&"
export * from "./MessageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports